<template>
    <div>
        <div class="row mb-1">
            <div class="col-6">
                <select-qualification-category
                        :allable="true"
                        :label="headers.qualification_category"
                        name="qualification_category"
                        ref="qualification_category"
                />
            </div>
            <div class="col-6">
                <select-qualification
                        :allable="false"
                        :label="headers.qualification"
                        name="staff_qualifications[qualification_id]"
                        ref="qualification"
                />
            </div>
        </div>
        <div class="row mb-1">
            <div class="col-12">
                <input-files-drag :disable_delete="true"
                                  :label="headers.file"
                                  :multiple="false"
                                  id="staff_qualifications_file"
                                  name="staff_qualifications_file"
                                  ref="qualification_file"
                />
            </div>
        </div>
        <div class="row mb-1">
            <div class="col-12 text-right mb-1">
                <button @click="addHistory()" class="btn btn-primary" type="button">追加</button>
            </div>
        </div>
        <div class="row mb-1">
            <div class="col-12">
                <table class="table table-striped table-sm">
                    <thead class="thead-light">
                    <tr>
                        <th>{{ headers.qualification_category }}</th>
                        <th>{{ headers.qualification }}</th>
                        <th width="100px"/>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(history, index) in getHistories">
                        <td> {{ history.category_name }}</td>
                        <td v-if="history.file_id && history.file_id !== '0' && !history.id">
                            <a target="_blank" v-bind:href="'/admin/commons/file/downloadTemporary/' + history.file_id">
                                {{ history.name }}
                            </a>
                        </td>
                        <td v-else-if="history.file_id && history.file_id !== '0' && 0 < history.id">
                            <a target="_blank"
                               v-bind:href="'/admin/staff/staffQualificationFiles/download/' + history.id">
                                {{ history.name }}
                            </a>
                        </td>
                        <td v-else> {{ history.name }}</td>

                        <td>
                            <button-confirm
                                    :func-ok="function() { removeHistory(index) }"
                                    classes="btn-danger btn-small"
                                    label="削除"
                                    message="本当に削除してよろしいですか？"
                                    title="データを削除しようとしています"
                            >
                            </button-confirm>
                            <input type="hidden" v-bind:name="getInputName(history.id, index, 'category_name')"
                                   v-model="history.category_name"/>
                            <input type="hidden" v-bind:name="getInputName(history.id, index, 'name')"
                                   v-model="history.name"/>
                            <input type="hidden" v-bind:name="getInputName(history.id, index, 'qualification_id')"
                                   v-model="history.qualification_id"/>
                            <input type="hidden"
                                   v-bind:name="getInputName(history.id, index, 'file_id')"
                                   v-if="history.file_id && history.file_id !== '0'"
                                   v-model="history.file_id"/>
                            <input type="hidden" v-bind:name="getInputName(history.id, index, 'id')" v-if="history.id"
                                   v-model="history.id"/>
                            <input type="hidden" v-bind:name="getInputName(history.id, index, 'updated_at')"
                                   v-if="history.id"
                                   v-model="history.updated_at"/>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import SelectQualificationCategory from '../../forms/selectQualificationCategoryComponent';
    import SelectQualification from '../../forms/selectQualificationComponent';
    import InputFilesDrag from '../../forms/InputFilesDragComponent';

    export default {
        name: "QualificationsComponent",
        components: {
            SelectQualificationCategory,
            SelectQualification,
            InputFilesDrag,
        },
        props: {
            name: String,
        },
        data() {
            return {
                headers: {
                    qualification_category: appUtil.getLang('validation.attributes.qualification.qualification_category'),
                    qualification: appUtil.getLang('validation.attributes.qualification.qualification'),
                    qualification_file: appUtil.getLang('validation.attributes.client_trouble_histories.comment'),
                },
                histories: [],
            };
        },
        mounted() {
            //既存データの取得
            $('.old_' + this.name).each((box, elem) => {
                let history = {};
                $(elem).find('input').each((input, prop) => {
                    let name = $(prop).prop('name');
                    history[name] = $(prop).val();
                });
                this.histories.push(history);
            }).remove();
        },
        methods: {
            addHistory() {
                // バリデーション
                if (!this.validation()) {
                    return false;
                }

                // ファイルを取得
                let file = this.$refs['qualification_file'].files[0];
                let file_id = null;
                if (file) {
                    file_id = file.response.id;
                }

                //要素追加
                this.histories.push({
                    category_name: this.$refs['qualification'].description_category,
                    name: this.$refs['qualification'].description,
                    qualification_id: this.$refs['qualification'].input,
                    file_id: +file_id,
                    updated_at: null,
                });

                //入力値をリセット
                this.$refs['qualification_category'].input = "";
                this.$refs['qualification_category'].error = null;
                this.$refs['qualification'].input = "";
                this.$refs['qualification'].error = null;
                this.$refs['qualification_file'].$refs['staff_qualifications_file'].clear();
            },
            validation() {
                let isValid = true;
                if (!this.$refs['qualification'].input) {
                    isValid = false;
                    this.$refs['qualification'].error = appUtil.getLang('validation.required', {
                        attribute: '資格'
                    });
                }
                return isValid;
            },
            getInputName(id, index, param) {
                if (!id) {
                    return this.name + '[new][' + index + '][' + param + ']';
                } else {
                    return this.name + '[old][' + id + '][' + param + ']';
                }
            },
            removeHistory(index) {
                this.histories.splice(index, 1);
            }
        },
        computed: {
            getHistories() {
                if (!this.histories) {
                    return this.histories;
                }

                // 2件以下の場合はそのまま返す
                if (this.histories.length < 2) {
                    return this.histories;
                }

                return this.histories;
            },
        }
    }
</script>

<style scoped>

</style>